export const getCurrentPage = (page: string) => Math.round(+page / 10) + 1
